export const i18n = {
  resources: {
    "en-US": {
      translations: {
        language: 'English (US)',
        chooseLanguage: 'Select Language',
        faqHeader: 'Frequently Asked Questions',
        checkPaymentStatus: 'Check Payment Status',
        chooseDifferentPaymentOption: 'Choose different payment option',
        validatePayment: {
          initialVisit: {
            title: 'Loading Paywall',
          },
          returningFromOauth: {
            title: 'Fetching User Info',
          },
        },
        octForm: {
          cardNumber: 'Card Number',
          expiration: 'Exp',
          zip: 'Zip',
          cvv: 'CVV',
          fullName: 'Full Name',
        },
        buttons: {
          "go": "go",
          "proceed": "proceed",
          "next": "next",
          "submit": "submit",
          "ok": "ok",
        }
      }
    },
    "es-MX": {
      translations: {
        language: 'Español (MX)',
        chooseLanguage: 'Elegir Idioma',
        checkPaymentStatus: 'Verificar el Estado del Pago',
        faqHeader: 'Preguntas Frecuentes',
        chooseDifferentPaymentOption: 'Elige una opción de pago diferente',
        octForm: {
          cardNumber: 'Número de Tarjeta',
          expiration: 'Vencimiento',
          zip: 'Código Postal',
          cvv: 'CVV',
          fullName: 'Nombre Completo',
        },
        buttons: {
          "go": "ir",
          "proceed": "proceder",
          "next": "próximo",
          "submit": "enviar",
          "ok": "Está bién",
        },
      }
    }
  }
};

export default i18n;
